import Typography from "@mui/material/Typography";
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import { returnArg, sanitizeFieldProps } from "../utils";

export class LinkField extends React.PureComponent {
  static defaultProps = {
    addLabel: true,
  };
  static propTypes = {
    addLabel: PropTypes.bool,
    basePath: PropTypes.string,
    className: PropTypes.string,
    cellClassName: PropTypes.string,
    headerClassName: PropTypes.string,
    label: PropTypes.string,
    record: PropTypes.object,
    sortBy: PropTypes.string,
    source: PropTypes.string.isRequired,
  };
  render() {
    const {
      children,
      className,
      formatURL = returnArg,
      source,
      sourceText,
      record = {},
      ...rest
    } = this.props;
    return (
      <Typography
        component={Link}
        body1="body1"
        className={className}
        to={formatURL(get(record, source))}
        {...sanitizeFieldProps(rest)}
      >
        {sourceText ? get(record, sourceText) : children}
      </Typography>
    );
  }
}
